<template>
  <div>
    <iframe :src="userPageUrl" width="100%" style="height: calc(100vh - 40px);" frameborder="0"
      allowfullscreen></iframe>
  </div>
</template>


<script>
import api from "@/api/projectApi";
import { siteMixins } from "@/mixins/tabChang";
import store from "@/store";
import request from "@/router/axios";
import { log } from "@chenfengyuan/vue-qrcode";
// 加密
import CryptoJS from 'crypto-js';
import DateUtil from 'dateutil';

export default {
  name: 'qualityStatement',

  data() {
    return {
      props: { multiple: true },
      userPageUrl: "",
      externalLink: "",
      otherUrl2:null


    }
  },
  created() {
    this.goOtherUrl()

    // console.log(CryptoJS, "CryptoJSCryptoJSCryptoJSCryptoJS", DateUtil);

    // 获取当前日期
    // const today = DateUtil.today();

    // 格式化日期
    // const formattedDate = DateUtil.date()
    // console.log(formattedDate, "formattedDate时间");

    // const content = "huadi,dw_huadi," + "2024-05-17 10:00:00"
    // const secretKey = 'cDfcmMhgr0YM1ktD'
    // const iv = ''
    // const key = CryptoJS.enc.Utf8.parse(secretKey)
    //  let vis = CryptoJS.enc.Utf8.parse(iv)


    // var encrypt = CryptoJS.AES.encrypt(content, key, {
    //   //  iv: vis, //iv偏移量 CBC需加偏移量
    //   mode: CryptoJS.mode.ECB, //CBC模式
    //   // mode: CryptoJS.mode.ECB, //ECB模式
    //   padding: CryptoJS.pad.Pkcs7 //padding处理

    // })
    // this.encrypt(content, secretKey)

    // console.log(encrypt.toString(), "加密后结果");
    // let password = encrypt.toString()
   

  },

  mounted() {

  },

  methods: {
   encrypt(content, encryptKey) { 
      if (!encryptKey || encryptKey.trim().length === 0) {
         throw new Error("encryptKey is empty!"); 
        } else { 
          const keyHex = CryptoJS.enc.Utf8.parse(encryptKey);
           const encrypted = CryptoJS.AES.encrypt(content, keyHex, {
             mode: CryptoJS.mode.ECB,
              padding: CryptoJS.pad.Pkcs7, }); 
    console.log( encrypted.toString(), "加密后结果");
          
           return encrypted.toString();
    // console.log( encrypted.toString(), "加密后结果");

          
           }
            },
doTobb() {
  this.$http({
    url: "/basic/soOrderDispatch/getOtherIndex",
    method: 'post',
  }).then(res => {
    this.userPageUrl = this.externalLink + res.data.data
    // window.open("http://dw.sc.5mall.com/web1/#/report/vform/out_render?reportCode=231218&dw="+res.data.data)
  })


},
goOtherUrl() {
  this.$http({
    url: "basic/soOrderDispatch/getCrypAes",
    method: 'post',
  }).then(res => {
    console.log(res.data.data,"Hello44");
    this.otherUrl2 = res.data.data
    console.log(this.otherUrl2,"otherUrl2的值888888889999");
    console.log(this.$route.query, "123132123132", );

if (this.$route.query.htt == 0) {
  var ht = 'http://'
} else if (this.$route.query.htt == 1) {
  var ht = 'https://'
} else {
  var ht = ''
}
console.log(ht, " ht9696696");
let str = ht + this.$route.query.url
console.log(str, "完整路由");
console.log(str.indexOf("dw=true") != -1, "dw=truedw=truedw=truedw=truedw=true");
if (str.indexOf("dw=true") != -1) {
  //截取第一个？前面的字符串
  // var str1 = str.indexOf("dw=true")
  var resolve = str.match(/(\S*)dw=true/)[1]
  var resolves2 = str.match(/dw=true(\S*)/)[1];
  console.log(resolve, resolves2, "网址前")
  let otherUrl = resolve + 'dw=' + this.otherUrl2 + resolves2
  // console.log(otherUrl, "582")
  // 处理加密后的完整路由
  this.externalLink = otherUrl
  console.log(this.externalLink, "58555555551");
  this.userPageUrl =    this.externalLink

  // this.doTobb();
  // window.close()
} else {
  this.externalLink = str
  this.userPageUrl = str
}
    // this.userPageUrl = this.externalLink + res.data.data
    // window.open("http://dw.sc.5mall.com/web1/#/report/vform/out_render?reportCode=231218&dw="+res.data.data)
  })


},
  }

};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
